import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from "firebase/messaging";
import { LogErrors } from "./utils/LogErrors";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBd6eDCPX6XmkC3heSRjxd6vLFgWbJVuog",
  authDomain: "sports-guardian-pwa.firebaseapp.com",
  projectId: "sports-guardian-pwa",
  storageBucket: "sports-guardian-pwa.appspot.com",
  messagingSenderId: "259013966353",
  appId: "1:259013966353:web:de4194fab65c99f6224fb0"
};

const app = initializeApp(firebaseConfig);
const  messaging = getMessaging(app);

getToken(messaging, { vapidKey: import.meta.env.VAPID_PUBLIC_KEY }).then((currentToken) => {
  if (currentToken) {
    localStorage.setItem("firebaseToken", currentToken);
  } else {
    //LogErrors(user, logout, updateTokens, 'No registration token available. Request permission to generate one.');
    localStorage.removeItem("firebaseToken");
  }
}).catch((err) => {
  // LogErrors(user, logout, updateTokens, 'An error occurred while retrieving token. ', err);
  localStorage.removeItem("firebaseToken");
});

export { app, firebaseConfig, messaging };

